export const getTagSVGStyle = () => ({
  container: {
    fontSize: '16px',
    lineHeight: '24px',
    color: '#323130',
    marginBottom: '12px',
    '& .svg-text': {
      'white-space': 'pre',
    },
  },
});
